// 全局弹窗和其他持久化数据
import { create } from "zustand";

const globalStore: any = create((set: any, get: any) => ({
  dialog: {
    params: {},
    "wx-login": false,
    "sure-info": false,
  },
  setDialog: (name: string, value: boolean, params?: any) =>
    set(() => ({
      dialog: {
        ...get().dialog,
        [name]: value,
        params: params || {},
      },
    })),
}));

export default globalStore;
